module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/big/3-2fc4d18f8a1ac6898c3e6a6d41f3ef71.webp";